import { defineStore } from 'pinia';
import $api from '@/plugins/axios';

export const useStatStore = defineStore('StatStore', {
  state: () => {
    return {
      rooms: {
        content: [],
        pageInfo: {},
        chartData: [],
      },
      roomUserJoins: {
        content: [],
        pageInfo: {},
        chartData: [],
      },
      studentHistory: {
        content: [],
      },
      managerHistory: {
        content: [],
      },
      userRank: null
    };
  },
  actions: {
    /** [스터디 통계] 이력 목록 */
    async getRegisterRooms(params) {
      return await $api.get('/stats/studies/rooms/registrations', { params });
    },

    /** [스터디 통계] 통계 그래프 */
    async getRegisterRoomsGraph(params) {
      try{
        const res = await $api.get('/stats/studies/rooms/registrations-for-chart', { params });
        this.rooms.chartData = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [접속 통계] 이력 목록 */
    async getJoinRoomUsers(params) {
      return await $api.get('/stats/studies/room-users/joins', { params });
    },

    /** [접속 통계] 이력 그래프 */
    async getJoinRoomUsersGraph(params) {
      try{
        const res = await $api.get('/stats/studies/room-users/joins-for-chart', { params });
        this.roomUserJoins.chartData = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    async getStudentHistory(params) {
      try {
        const res = await $api.get('/stats/students', { params });
        this.studentHistory.content = res;
      } catch (e) {
        this.$handleError(e);
      }
    },

    async getManagerHistory(params) {
      try{
        const {customerId, ...restParams} = params;
        const res = await $api.get(`/stats/${customerId}/group`, { params: restParams });
        this.managerHistory.content = res;
      }catch(e) {
        this.$handleError(e);
      }
    },
    async getStudentRank(params){
      try{
        this.userRank = (await $api.get('/stats/students/rank', {params})).data;
      }catch(e) {
        this.$handleError(e);
      }
    },
    async getStatTargetTime(userId){
      try{
        return await $api.get(`/stats/${userId}/target-time`);
      }catch(e) {
        //
      }
    },

    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    }
  },
  getters: {},
});
